export class WitnessConstants {
  static dispenseSummaryText = 'Dispense Summary';
  static qohBeforeDispenseText = 'QOH Before Dispense';
  static qohBeforePurchaseOrderText = 'QOH Before Check Position';
  static qohAfterDispenseText = 'QOH After Dispense';
  static qohBeforeChargeText = 'QOH Before Charge';
  static qohBeforeMoveText = 'QOH Before Move';
  static qohBeforeRestockText = 'QOH Before Restock';
  static qohBeforeReturnText = 'QOH Before Return';
  static qohBeforeUnloadText = 'QOH Before Unload';
  static saveButtonText = 'Save and Continue';
  static dispenseLessQuantityDynamicMessage =
    'Position Quantity changed, Please skip this item to continue.';
  static dispenseOutOfStockDynamicMessage =
    'The item is <span class="form-control--static red">Out of Stock</span>. Please skip this item to continue.';
  static clinicChargeLessQuantityDynamicMessage =
    'Dispense quantity changed. Please skip this item to continue';
  static clinicChargeOutOfStockDynamicMessage =
    'The item is updated as <span class="form-control--static red">Out of Stock</span>, so you cannot clinic charge this item.';
  static transferOutItemOutOfStockDynamicMessage =
    'The item you selected is <span class="form-control--static red">Out of Stock</span>. Please skip this item to continue.';
  static qohBeforeTransferOut = 'QOH before Transfer Out';
  static qohBeforeCancelTransfer = 'QOH before Cancel Transfer';
  static qohBeforeTransferIn = 'QOH before Transfer In';
}
